import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idContactsContactStatus']),
        getByWork: state => work => {
            return state.objs.filter(status => status.work === work);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idContactsContactStatus'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idContactsContactStatus'])
    },
}